import { render } from "./dismiss.vue?vue&type=template&id=00f08e90"
import script from "./dismiss.vue?vue&type=script&lang=js"
export * from "./dismiss.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ydd\\h5\\pda_dealer_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__